import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = { style: {"max-width":"200px","font-size":"14px"} }

import { computed, ref, onMounted, onBeforeUnmount } from 'vue'
import STable from '@/components/Table/index.vue'
import { WarningFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import AbnormalContent from './AbnormalContent.vue'
import AbnormalBtn from './AbnormalBtn.vue'
import Countdown from './Countdown.vue'
import { abnormalDegreeDescList } from '@/common/const'
import PreViewImg from '@/components/common/PreViewImg.vue'
import { getJapanTime } from '@/util/common'
import { handleResult } from '../index'

export default /*#__PURE__*/_defineComponent({
  props: ['details', 'customerOperateStatus'],
  emits: ['open'],
  setup(__props, { emit }) {

const props = __props




const tableData = props?.details?.map((v: any) => {
  return {
    ...v,
    abnormalDetailMessageSeverity: JSON.parse(v.abnormalDetailMessageSeverity)
    // abnormalDetailMessageJp: v.abnormalDetailMessageJp?.split(',')
  }
})

const columns = computed(() => {
  return props.customerOperateStatus === 1 ? [
    {
      label: t('商品问题原因'),
      prop: 'degree',
      slotName: 'degree'
    },
    {
      label: t('异常图片'),
      prop: 'img',
      slotName: 'img'
    },
    {
      label: t('异常数量'),
      prop: 'num'
    },
    {
      label: t('问题生成时间'),
      prop: 'createTime',
      slotName: 'createTime'
    }
  ] : [
    {
      label: t('商品问题原因'),
      prop: 'degree',
      slotName: 'degree'
    },
    {
      label: t('异常图片'),
      prop: 'imageList',
      slotName: 'img'
    },
    {
      label: t('异常数量'),
      prop: 'num'
    },
    {
      label: t('问题生成时间'),
      prop: 'createTime',
      slotName: 'createTime'
    },
    {
      label: t('处理方式'),
      prop: 'customerOperateMessage',
      slotName: 'customerOperateMessage'
    }]
})

const translateDegree = (key: any) => {
  return abnormalDegreeDescList[key]
}

const openProblemVisible = (row: any) => {
  emit('open', row)
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(STable, {
    tableData: _unref(tableData),
    columns: _unref(columns),
    showPagination: false,
    tableConfig: {
    showHandler: true,
  }
  }, {
    degree: _withCtx((scope) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AbnormalContent, {
          rowItem: scope.row
        }, null, 8, ["rowItem"]),
        (__props.customerOperateStatus === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (scope.rowIndex > -1 && scope.row.type === 8)
                ? (_openBlock(), _createBlock(Countdown, {
                    key: 0,
                    time: scope.row.createTime,
                    dealTime: 3
                  }, null, 8, ["time"]))
                : _createCommentVNode("", true),
              (scope.row.type <= 6)
                ? (_openBlock(), _createBlock(Countdown, {
                    key: 1,
                    time: scope.row.createTime,
                    dealTime: 60
                  }, null, 8, ["time"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    img: _withCtx(({ row }) => [
      _createVNode(_component_el_popover, {
        placement: "right-start",
        width: 400,
        trigger: "hover",
        "popper-class": "defectiveImgPop",
        "popper-style": "border:none;border-radius: 8px;box-shadow: 0px 6px 12px 0px #ECECEC;"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_image, {
            style: {"width":"80px","height":"80px"},
            src: row?.imageList?.[0] || row.productImg,
            previewSrcList: row.imageList?.length ? row?.imageList.length : [row.productImg],
            "preview-teleported": true,
            fit: "contain"
          }, null, 8, ["src", "previewSrcList"])
        ]),
        default: _withCtx(() => [
          _createVNode(PreViewImg, {
            "img-list": row?.imageList || [row.productImg]
          }, null, 8, ["img-list"])
        ]),
        _: 2
      }, 1024)
    ]),
    customerOperateMessage: _withCtx(({ row }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref(handleResult)(row)) + " ", 1),
          (row.abnormalProcessType === 1 && row.abnormalProcessDetailType === 22)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('超过60天用户未处理，系统已自动处理')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    size: 12,
                    class: "cursor-pt"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(WarningFilled))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (row.abnormalProcessType)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "warning",
              effect: "dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('自动退货')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    createTime: _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
    ]),
    handler: _withCtx(({ scope }) => [
      _createVNode(AbnormalBtn, {
        rowItem: scope.row,
        customerOperateStatus: props.customerOperateStatus,
        onOpen: openProblemVisible
      }, null, 8, ["rowItem", "customerOperateStatus"])
    ]),
    _: 1
  }, 8, ["tableData", "columns"]))
}
}

})